<div class="d-flex justify-content-between border-bottom pb-3 my-3">
    <h6 class="h6 fw-bold d-inline-block mb-0">{{ title }}</h6>
    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
        <ol class="breadcrumb breadcrumb-links">
            <li class="breadcrumb-item"><a class="text-decoration-none" [routerLink]="['/']">Home</a></li>
            <li class="breadcrumb-item"><a class="text-decoration-none" [routerLink]="['/employee']">Employee</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ title }}</li>
        </ol>
    </nav>
</div>